module.exports = __webpack_public_path__ + "static/img/v20Bg-p.2570443.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/v20Bg-p.png
// module id = s5Hi
// module chunks = 1